/**
 * WebSocket Connection States
 * Tracks the current state of the AG-UI WebSocket connection
 */

export const CONNECTION_STATES = {
    /** Initial state, not connected */
    DISCONNECTED: 'DISCONNECTED',
    /** Connection attempt in progress */
    CONNECTING: 'CONNECTING',
    /** Successfully connected and ready */
    CONNECTED: 'CONNECTED',
    /** Connection error occurred */
    ERROR: 'ERROR',
    /** Attempting to reconnect after disconnect */
    RECONNECTING: 'RECONNECTING'
};

/**
 * Check if connection state indicates an active connection
 * @param {string} state - Connection state
 * @returns {boolean}
 */
export const isConnected = (state) => state === CONNECTION_STATES.CONNECTED;

/**
 * Check if connection state indicates a pending connection
 * @param {string} state - Connection state
 * @returns {boolean}
 */
export const isConnecting = (state) => 
    state === CONNECTION_STATES.CONNECTING || 
    state === CONNECTION_STATES.RECONNECTING;

/**
 * Check if connection state indicates a problem
 * @param {string} state - Connection state
 * @returns {boolean}
 */
export const hasConnectionError = (state) => state === CONNECTION_STATES.ERROR;
